import { Navigate, useParams, useRoutes } from "react-router-dom";

import FeedRoutes from "./feed/routes";
import IndexPage from "./index";
import JournalRoutes from "./journal/routes";

export default () =>
  useRoutes([
    { path: "/feed/*", element: <WithParameters component={FeedRoutes}/> },
    { path: "/journal/*", element: <WithParameters component={JournalRoutes}/> },
    { path: "/", element: <WithParameters component={IndexPage}/> },
    { path: "/*", element: <Navigate to="/not-found"/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
